import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`useTransition`}</h1>
    <p>{`Similar to the CSSTransition component in `}<a parentName="p" {...{
        "href": "https://reactcommunity.org/react-transition-group/"
      }}>{`React Transition Group`}</a>{`, the `}<inlineCode parentName="p">{`useTransition`}</inlineCode>{` hook provides a way to animate adding and removing elements from the DOM.`}</p>
    <p>{`To implement the `}<inlineCode parentName="p">{`useTranstiion`}</inlineCode>{` hook in your component, add the import:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import useTransition from "@kiwicom/orbit-components/lib/hooks/useTransition";
`}</code></pre>
    <p>{`Then you can use it like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useState } from "react";
import styled, { css } from "styled-components";

const StyledAnimated = styled.div\`
  \${({ $enter }) => css\`
    transition: opacity 0.5s ease-in-out;
    opacity: \${$state === "enter" ? 1 : 0};
  \`};
\`;

const Component = (props: Props) => {
  const [show, setShow] = useState(true);
  const transition = useTransition({ show, appear: true });

  return (
    <>
      <button type="button" onClick={() => setShow(prev => !prev)}>
        Toggle
      </button>
      <StyledAnimated ref={transition.ref} $state={transition.state}>
        Hello world!
      </StyledAnimated>
    </>
  );
};
`}</code></pre>
    <h2>{`Options`}</h2>
    <p>{`The table below contains all options available to the `}<inlineCode parentName="p">{`useTransition`}</inlineCode>{` hook.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`show`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether to animate the element in or out of the DOM. The duration is defined by the `}<inlineCode parentName="td">{`transition-duration`}</inlineCode>{` CSS property.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`appear`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether to show the enter animation right away if `}<inlineCode parentName="td">{`show`}</inlineCode>{` is initially set to `}<inlineCode parentName="td">{`true`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Return`}</h2>
    <p>{`The table below contains all properties of the object returned by the `}<inlineCode parentName="p">{`useTransition`}</inlineCode>{` hook.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ref`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`{\\| current: HTMLElement \\| null \\|}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Ref object that should be passed to the HTML element being animated.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`mounted`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the component is mounted.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`state`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"enter" \\| "leave"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the element is entering or leaving the DOM.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`done`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the element is done transitioning.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      